import { Nullable } from '@ui/types/utility';
import { createContext, ReactNode, useContext, useMemo } from 'react';
import { IChartWidgetApi } from 'trading-view';

type ChartContextContextValue = {
  chartApi: Nullable<IChartWidgetApi>;
  /**
   * chart not ready when
   * - changing trading pair
   * - script loading on refresh
   * */
  isChartReady: boolean;
};

const ChartContextContext = createContext<ChartContextContextValue>({
  chartApi: undefined,
  isChartReady: false,
});

export const ChartContextContextProvider = ({
  children,
  chartApi,
  isChartReady,
}: ChartContextContextValue & {
  children: ReactNode;
}) => {
  const ctx = useMemo(() => {
    return {
      chartApi,
      isChartReady,
    };
  }, [chartApi, isChartReady]);

  return (
    <ChartContextContext.Provider value={ctx}>
      {children}
    </ChartContextContext.Provider>
  );
};

export const useChartContextContext = () => useContext(ChartContextContext);
